/**
 * The weeks a month grid shows for the month containing `selectedDate`: from the start of the
 * week the 1st falls in to the end of the week the last day falls in, so the grid is always
 * whole weeks. Each week is an array of seven moments at the start of their day.
 */
export const weeksFor = (selectedDate) => {
	const first = selectedDate.clone().startOf('month').startOf('week');
	const last = selectedDate.clone().endOf('month').endOf('week');
	const weeks = [];
	const day = first.clone();
	while(day.isBefore(last)) {
		const week = [];
		for(let i = 0; i < 7; i++) {
			week.push(day.clone());
			day.add(1, 'day');
		}
		weeks.push(week);
	}
	return weeks;
};

/** The first and last visible day, as `populateVisibleDates` wants them. */
export const visibleRange = (selectedDate) => {
	const weeks = weeksFor(selectedDate);
	const lastWeek = weeks[weeks.length - 1];
	return {
		start: weeks[0][0].clone(),
		end: lastWeek[6].clone().add(1, 'day'),
	};
};
